import { getDefaultLang } from "@cervval.js/common/src/i18n/languages";

const _fr = {
    noTs: "Pas de créneau ce jour"
};

export type _I18nBookingSliderElement = typeof _fr;

const _en: _I18nBookingSliderElement = {
    noTs: "No slot this day"
};

/**
 * Return value in required language
 * @param lang Chosen lang
 * @returns 
 */
export function I18nBookingSliderElement(lang?: string): _I18nBookingSliderElement {
    lang = lang ?? getDefaultLang();
    switch (lang) {
        case "en":
            return _en;
        case "fr":
        default:
            return _fr;
    }
}